import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DashedInput } from './input';
import { useReactToPrint } from 'react-to-print';
import { useEffect, useRef, useState } from 'react';

import PrintTemplate from './print_template';

import { useAPI } from '../../services/hoc/useAPI';
import { unit_type } from '../../services/api/api';
import { getCurrentDate } from '../../services/current_time';
import { Units } from './common';
interface iPage {
  area: string;
  glass: string;
  length: string;
  other_services: number;
  piece_code: string;
  ser: number;
  piece_count: string;
  service: string;
  width: string;
  note:string;
  unit?:unit_type
}

interface iState {
  client: string;
  delivery_date: string;
  invoice_number:string
  order_date: string;
  order_number: string;
  notes:string,
  glass_summary:string,
  glass_work_summary:string,
  pages: [{ page_number: number; page: iPage[] , page_piece_count:number,page_qty:number }];
}
interface iProps {
  data: any;
  close: Function;
  setWait?: Function;
}
export const PrintOrder = ({ data, close, setWait }: iProps) => {

 const api = useAPI()
  const [order, setOrder] = useState<iState | null>(null);
  const componenetRef = useRef(null);
const returnContentToprint= ()=> componenetRef.current
  const handlePrint = useReactToPrint({
   
    onAfterPrint: () => close(),
    documentTitle:'أمر شغل'
  });

  useEffect(() => {
    if (typeof data === 'object') {
      setOrder(data);
    } else {
      if (data) {
        api
          .orders()
          .printOrder({ id: parseInt(data) })
          .then((res: any) => {
            if (setWait) setWait(false);
            setOrder(res.data.data);
          })
          .catch((err: any) => {
            //console.log(err);
          });
      }
    }
  }, [data]);
  useEffect(() => {
    if (order) {
      handlePrint(returnContentToprint);
    
     
    }
  }, [order]);
    let _pages= undefined
    if (order) _pages=Array(order.pages.length).fill(1)
  
    //console.log('_pages',order)
  return (

    <div
    ref={componenetRef as any}
    className="printMe"
    style={{minHeight:'100vh'}}
  >
              
                  {order
                      ? 
                      order.pages.map((page,i)=> {
    return(
    <Grid size={12} container height={'100vh'} key={i}
   
  >
                    <Grid size={12} justifyContent="center" alignItems='center'
                              margin={1} display='flex' flexDirection='column'>
                                <span className={'fs-12'}> مصنع روشن الشرق للزجاج </span>
                                <span className={'fs-12 bolder'} > أمر التشغيل </span>
                          
                             </Grid>
                                <Grid
                          marginY={0}
                          container
                          size={12}
                          paddingY={0}
                          rowSpacing={0}
                          rowGap={0}
                          justifyContent="flex-end">
                              <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                <div style={{marginInline:'1rem'}}>
                                  {order.order_date?.replaceAll('-','/')}
                                </div>
                                <div>
                                  تاريخ الطلبية
                                </div>
                              </div>
                               <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                 <div style={{marginInline:'1rem'}}>
                                  {'Q'+order.order_number}
                                </div>
                                <div>
                                  رقم الطلبية
                                </div>
                             </div>
                              
                              <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                 <div style={{marginInline:'1rem'}}>
                                  {getCurrentDate(0)}
                                </div>
                                <div>
                                  تاربخ أمر التشغيل 
                                </div>
                              
                              </div>
                              <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                 <div style={{marginInline:'1rem'}}>
                                  {'R'+order.invoice_number}
                                </div>
                                <div>
                                  رقم عرض السعر
                                </div>
                             </div>
                            
                               <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                 <div style={{marginInline:'1rem'}}>
                                  {order.delivery_date?.replaceAll('-','/')}
                                </div>
                                <div>
                                  تاربخ التسليم  
                                </div>
                           
                              </div>
                                <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                    <div style={{marginInline:'1rem'}}>
                                  {order.client}
                                </div>
                                <div>
                                  اسم العميل  
                                </div>
                              
                              </div>
                             
                               <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'50%'
                              }}
                            className={'fs-12'} >
                                  <div style={{marginInline:'1rem'}}>
                                  {page.page_number}
                                </div>
                                <div>
                                 صفحة
                                </div>
                              
                                
                              </div>
                               <div   
                              style={{
                                display:'flex',
                                justifyContent:'flex-end',
                                width:'90%'
                              }}
                            className={'fs-12'} >
                                  <div style={{marginInline:'1rem'}}>
                                  {order.notes}
                                </div>
                                <div>
                                 ملاحظات
                                </div>
                           
                              </div>
                              
                        </Grid>

                                
                   
                     <>
                      
                        <Grid  container size={12} height={"60%"} 
                        justifyItems={'flex-start'} marginY={0} paddingY={0}>
                                <Grid  size={12}>
                                  <Table >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          <span>تشغيلات أخرى</span>
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            border: '1px dashed black',
                                          }}
                                          >
                                          التشغيلات
                                        </TableCell>

                                     
                                       <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          <span>الكمية</span>
                                 
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          العرض
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          الطول
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          العدد
                                        </TableCell>
                                        <TableCell style={{ border: '1px dashed black' }}>
                                          رمز القطعة
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}
                                          >
                                          الصنف
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px dashed black' }}>
                                          <span>المسلسل </span>
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {
                                         page.page.map((ele, index: number) => {
                        
                          if (ele) {
                            let services= ele.service.split('/')[1]
                            
                            return (
                                      <>
                                      <TableRow key={index}
                                    sx={{
                                          '& td, & th': {
                                            fontFamily: 'Arial, Helvetica, sans-serif',
                                            fontWeight: 700,
                                          },
                                        }}     
                                        
                                        >
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' ,textAlign:'left' ,paddingLeft:'5px'}}
                                          className="less_spaces"
                                        >
                                          {ele.other_services}
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4',textAlign:'left' ,paddingLeft:'5px' }}
                                          className="less_spaces"
                                      >
                                          {services}
                                        </TableCell>
                                        
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          {ele.unit&& ele.unit== 'Piece'?
                                          ele.area 
                                          :
                                          (parseFloat(ele.area) * parseInt(ele.piece_count)).toFixed(2)}
                                        </TableCell>

                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          {ele.width}
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          {ele.length}
                                        </TableCell>
                                         
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          {ele.piece_count}
                                        </TableCell>
                                         <TableCell
                                          style={{ border: '1px solid #a7a4a4' ,textAlign:'left' ,paddingLeft:'5px'}}
                                          className="less_spaces">
                                          {ele.piece_code}
                                        </TableCell>
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' ,textAlign:'left' ,paddingLeft:'5px'}}
                                          className="less_spaces">
                                          {ele.glass + '('+Units[ele.unit as unit_type]+')'}
                                        </TableCell>
                                      
                                        <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          {ele.ser}
                                        </TableCell>
                                       
                                       
                                      </TableRow>
                                     { index === page.page.length -1 && 
                                      <TableRow       sx={{
                                          '& td, & th': {
                                            fontFamily: 'Arial, Helvetica, sans-serif',
                                            fontWeight: 700,
                                          },
                                        }}    
                                      >
                                          <TableCell   style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">

                                          </TableCell>
                                          <TableCell  style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                            
                                          </TableCell>
                                          <TableCell   style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                              {page.page_qty.toFixed(2)}
                                          </TableCell>
                                        
                                          <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          
                                        </TableCell>
                                            <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                        
                                        </TableCell>
                                          <TableCell   style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                              {page.page_piece_count}
                                          </TableCell>
                                           <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                          
                                        </TableCell>
                                         <TableCell
                                          style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">
                                         
                                        </TableCell>
                                       <TableCell   style={{ border: '1px solid #a7a4a4' }}
                                          className=" less_spaces">

                                          </TableCell>
                                      </TableRow>
                                      }
                                      </>
                                    
                                         )
                          }
                        }
                      )
                    }
                                    </TableBody>
                                  </Table>
                                </Grid>
                        </Grid>
                        </>
             
           
              </Grid>)
                    })
                         
                         : null}
                  
                     </div>
                    

  )
};
